import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class BrokerChargeCommUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.brokerChargeComm(req);
    }
}
export default BrokerChargeCommUseCase;
